import { useEffect, useRef } from 'react';

import { Box, Grid, Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { useLanguageContext } from '@lumirental/lumi-web-shared/lib/contexts/Language.context';

import { useIRContext } from '../../Layout/IRLayout';

import styles from './EuroLandWidget.style';

const useStyles = makeStyles()(styles);

export default function EuroLandWidget({
  id = 'euroWidget',
  title,
  widgetSrc,
  longLang,
}) {
  const { classes } = useStyles();

  const widgetRef = useRef();
  const { language, isArabic } = useLanguageContext();
  const { isScriptLoaded } = useIRContext();

  const arabicLang = longLang ? 'arabic' : 'ar-ae';
  const lang = `lang=${isArabic ? arabicLang : 'en-gb'}`;

  useEffect(() => {
    if (isScriptLoaded && id) {
      window?.EurolandToolIntegrationObject?.set(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScriptLoaded, widgetRef?.current]);

  return (
    <>
      <Box marginTop={{ md: 3 }} padding={{ xs: 2, lg: 0 }}>
        {title && (
          <Grid item xs={12} marginTop={5}>
            <Typography
              id={`id-${id}`}
              variant="h2"
              className={classes.sectionTitle}
            >
              {title[language]}
            </Typography>
          </Grid>
        )}

        <iframe
          ref={widgetRef}
          id={id}
          title={title?.[language] || 'lumi'}
          src={`${widgetSrc}${lang}`}
          scrolling="no"
          frameBorder="0"
        />
      </Box>
    </>
  );
}
